// material-ui
import {
  Grid,
  Typography,
  Box,
  Avatar,
  Icon,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  InputAdornment,
  IconButton,
  TextField,
  DialogActions,
  Skeleton
} from "@mui/material";

// assets
import React, { useEffect, useState } from "react";
import {
  type IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto,
  type IntranetPortal_Occasions_Dtos_MessageListForMyBirthdayDto,
  OccasionService
} from "../../../services/intranet-portal-services";
import useIntranetPortalCoreApi from "../../../hooks/useIntranetPortalAdminApi";
import EmojiPicker from "emoji-picker-react";
import EmojiEmotionsOutlinedIcon from "@mui/icons-material/EmojiEmotionsOutlined";

// import  RedeemIcon  from '@material-ui/icons';
import { MdOutlineCake } from "react-icons/md";
import { BirthCard } from ".";
import { FiMessageSquare } from "react-icons/fi";
import { BiMessageSquareCheck } from "react-icons/bi";
import CustomButton from "../../../ui-component/CustomUiComponent/Button";
import Confetti from "react-confetti";
import { toast } from "react-toastify";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import dayjs from "dayjs";
import CustomAvatar from "../../../ui-component/CustomUiComponent/Avatar";

// ==============================|| DASHBOARD - TOTAL INCOME LIGHT CARD ||============================== //

// skeleton loading
export const SkeletonLoading = (): React.ReactElement => (
  <Box sx={{ display: "flex", gap: "2rem", padding: "1rem" }}>
    <Skeleton animation="wave" variant="circular" width="40px" height="40px" />
    <Box sx={{ width: "100%", flex: 1 }}>
      <Skeleton animation="wave" width="100%" />
      <Skeleton animation="wave" width="50%" />
    </Box>
  </Box>
);

const BirthdayCelebration = (): React.ReactElement => {
  const { handleRequest, isLoading } = useIntranetPortalCoreApi();

  const [allbirthdayToday, setAllbirthdayToday] = useState<
    IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto[]
  >([]);
  const [myBirthday, setMyBirthday] =
    useState<IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto>();
  const [messagesToMe, setMessagesToMe] = useState<
    IntranetPortal_Occasions_Dtos_MessageListForMyBirthdayDto[]
  >([]);
  const [messagesByMe, setMessagesByMe] = useState<
    IntranetPortal_Occasions_Dtos_MessageListForMyBirthdayDto[]
  >([]);
  // const [isBirthdayDialogOpen, setBirthdayDialogOpen] = useState(false)
  const [isBirthdayMessageDialogOpen, setBirthdayMessageDialogOpen] = useState(false);
  const [wishMessage, setWishMessage] = useState("");
  const [sendWishDialogOpen, setSendWishDialogOpen] = useState<any>();
  const [showConfetti, setShowConfetti] = useState(false);
  const [showWish, setShowWish] = useState<any>();
  const [showPicker, setShowPicker] = useState(false);
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const windowHeight = window.innerHeight ?? 300;
  const windowWidth = window.innerWidth ?? 300;

  const getMyBirthday = async (): Promise<void> => {
    await handleRequest(() => OccasionService.getCoreApiApiAppOccasionMyBirthdayToday()).then(
      (response) => {
        if (response != null) {
          setMyBirthday(response);
        } else {
          localStorage.setItem("hasSeenPopup", "false");
        }
      }
    );
  };

  const getAllEmployeeWithBirthday = async (): Promise<void> => {
    await handleRequest(() =>
      OccasionService.getCoreApiApiAppOccasionEmployeesListForBirthdayToday()
    ).then((response) => {
      if (response != null) {
        setAllbirthdayToday(response);
      }
    });
  };

  const getMyBirthdayMessages = async (): Promise<void> => {
    const id = myBirthday?.occasionId;

    if (id != null) {
      await handleRequest(() =>
        OccasionService.getCoreApiApiAppOccasionMessageListForMyBirthday(id)
      ).then((response) => {
        if (response != null) {
          setMessagesToMe(response);
        }
      });
    }
  };

  // SEND WISH MESSAGE
  const sendWishMessage = async (
    occasionId: string,
    fullName: string,
    wishedMessage: string
  ): Promise<void> => {
    const payload = { occasionId, wishedMessage };
    await handleRequest(() => OccasionService.postCoreApiApiAppOccasionWishBirthday(payload)).then(
      async (response) => {
        if (response != null) {
          setWishMessage("");
          await getAllMyWishes();
          handleSendWishDialogClose();
          toast.success(`Send to ${fullName}`, {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light"
          });
        }
      }
    );
  };

  const getAllMyWishes = async (): Promise<void> => {
    await handleRequest(() =>
      OccasionService.getCoreApiApiAppOccasionBirthdayMessageListSentByMeToday()
    ).then((response) => {
      if (response != null) {
        setMessagesByMe(response);
      }
    });
  };

  useEffect(() => {
    void getMyBirthday();
    void getAllEmployeeWithBirthday();
    void getAllMyWishes();
  }, []);

  useEffect(() => {
    void getMyBirthdayMessages();
  }, [myBirthday]);

  const handleSendWishDialogOpen = (occasionId: string): void => {
    setSendWishDialogOpen(occasionId);
    setErrorMessage("");
  };

  const handleSendWishDialogClose = (): void => {
    setWishMessage("");
    setSendWishDialogOpen(true);
    setErrorMessage("");
  };
  const handleMessageDialogOpen = (): void => {
    setBirthdayMessageDialogOpen(true);
  };

  const handleMessageDialogClose = (): void => {
    setBirthdayMessageDialogOpen(false);
  };

  const handleConfetti = (): void => {
    setShowConfetti(true);
    setTimeout(() => {
      setShowConfetti(false);
    }, 6000);
  };

  const handleShowWishOpen = (occasionId: string): void => {
    setShowWish(occasionId);
  };

  const handleShowWishClose = (): void => {
    setShowWish("");
  };

  // const matchMessageId = messagesByMe?.find((message: any): void => {
  //   allbirthdayToday?.find((employee: any) => employee.occasionId === message.occasionId)
  // })

  const onEmojiClick = (emojiObject: { emoji: string }): void => {
    if (wishMessage.length < 280) {
      setWishMessage(wishMessage + emojiObject.emoji);
    } else {
      setErrorMessage("maximum length reached");
    }
  };

  const handlePopupClose = (): void => {
    setIsFirstLogin(false);
    localStorage.setItem("hasSeenPopup", "true");
  };

  useEffect(() => {
    // Check if the user has seen the popup before
    const hasSeenPopup = localStorage.getItem("hasSeenPopup");
    if (hasSeenPopup !== undefined && hasSeenPopup !== "true") {
      setIsFirstLogin(true);
    }
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          <SkeletonLoading />
        </>
      ) : (
        <>
          {/* Login Birthday Celebration PopUp */}
          {isFirstLogin
            ? myBirthday != null && (
                <Dialog
                  PaperProps={{
                    style: {
                      overflow: "initial"
                    }
                  }}
                  style={{ backdropFilter: "blur(2px)" }}
                  open={isFirstLogin}
                  onClose={handlePopupClose}
                >
                  <Confetti
                    height={windowHeight}
                    width={windowWidth}
                    numberOfPieces={200}
                    style={{ position: "fixed", top: 0, left: 0 }}
                  />
                  <BirthCard className="birthCard cardView popUpCard" style={{ marginTop: 0 }}>
                    <Avatar className="avatar" src={`${myBirthday.profilePictureUrl as string}`} />
                    <Box className="birthCard_content">
                      <Box sx={{ flex: 1 }}>
                        <Box className="user">
                          <Box component="span">{myBirthday.fullName}</Box>
                        </Box>
                        <Box className="designation">{myBirthday.designationName}</Box>
                        <Box
                          sx={{
                            color: "#D42C2C",
                            fontWeight: "500",
                            mt: 2
                          }}
                        >
                          <Box
                            className="typing"
                            sx={{
                              fontSize: "16px",
                              color: "#313131",
                              lineHeight: "24px"
                            }}
                          >
                            Hello {myBirthday.fullName}.{" "}
                            <Box
                              component="span"
                              style={{
                                fontSize: "24px",
                                color: "#D42C2C",
                                fontFamily: "cursive"
                              }}
                            >
                              Happy Birthday!{" "}
                            </Box>
                            May your birthday be the start of a year filled with good luck, good
                            health and much happiness
                          </Box>
                        </Box>
                        <Box sx={{ width: "100%", textAlign: "end" }}>
                          <Box component="span" className="date">
                            ~ HR
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </BirthCard>
                </Dialog>
              )
            : ""}

          {/* Birthday And Received Messages */}
          {myBirthday != null ? (
            <BirthCard className="birthCard" style={{ marginTop: 0, marginBottom: "1rem" }}>
              <Avatar className="avatar" src={`${myBirthday.profilePictureUrl as string}`} alt="" />
              <Box className="birthCard_content">
                <Box>
                  <Box className="user">
                    <Box
                      sx={{
                        fontWeight: 400,
                        color: "#d82d2b",
                        mr: 1,
                        fontSize: "16px"
                      }}
                    >
                      Birthday greetings,
                    </Box>
                    {myBirthday.fullName}
                  </Box>
                  {messagesToMe?.length > 0 ? (
                    <Button
                      onClick={() => {
                        handleMessageDialogOpen();
                        handleConfetti();
                      }}
                      sx={{
                        ml: -1,
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                        color: "#D42C2C",
                        fontWeight: "500"
                      }}
                    >
                      <FiMessageSquare />
                      <Box sx={{ fontSize: "12px" }}>You received {messagesToMe.length} wishes</Box>
                    </Button>
                  ) : null}

                  {messagesToMe != null && messagesToMe?.length > 0 ? (
                    <Dialog
                      PaperProps={{
                        style: {
                          maxHeight: "550px",
                          overflowY: "auto",
                          width: "100%"
                        }
                      }}
                      open={isBirthdayMessageDialogOpen}
                      onClose={handleMessageDialogClose}
                    >
                      {showConfetti && <Confetti height={170} width={550} numberOfPieces={40} />}
                      <DialogTitle>Received Messages Inbox</DialogTitle>
                      <DialogContent sx={{ width: "100%" }}>
                        {/* Display the rest of the wish msg items */}
                        {messagesToMe?.map((item: any) => (
                          <>
                            <BirthCard
                              className="birthCard"
                              style={{ marginTop: 0, marginBottom: "5px" }}
                              key={item.wishedById}
                            >
                              {showConfetti && (
                                <Confetti
                                  height={90}
                                  width={550}
                                  opacity={0.9}
                                  numberOfPieces={40}
                                />
                              )}
                              <Avatar className="avatar" src={item?.profilePictureUrl} alt="" />
                              <Box className="birthCard_content">
                                <Box sx={{ flex: 1 }}>
                                  <Box className="user">{item.wishedByFullName}</Box>
                                  <Box className="designation">
                                    {/* {item.wishedByDepartmentName}, */}
                                    {item.wishedByDesignationName}
                                  </Box>

                                  <Box
                                    sx={{
                                      color: "#D42C2C",
                                      fontWeight: "500",
                                      mt: 1
                                    }}
                                  >
                                    <Box sx={{ fontSize: "16px" }}>{item.wishedMessage}</Box>
                                  </Box>
                                  <Box sx={{ width: "100%", textAlign: "end" }}>
                                    <Box component="span" className="date">
                                      ~ {dayjs(item.wishedOn).format("HH:mm")}
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </BirthCard>
                          </>
                        ))}
                      </DialogContent>
                    </Dialog>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
            </BirthCard>
          ) : (
            ""
          )}

          {/* All Birthday Today  */}

          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "400",
                mb: "0.5rem",
                display: "flex",
                lineHeight: "32px"
              }}
            >
              <Icon color="primary" sx={{ mr: "8px" }}>
                <MdOutlineCake size="2rem" />
              </Icon>
              Birthday Today
            </Typography>

            {allbirthdayToday != null && allbirthdayToday?.length >= 1 ? (
              <>
                {allbirthdayToday
                  .sort((a: any, b: any) => {
                    if (
                      messagesByMe.find((message: any) => message.occasionId === a.occasionId) !=
                        null &&
                      messagesByMe.find((message: any) => message.occasionId === b.occasionId) ==
                        null
                    ) {
                      return 1; // Move a to the bottom
                    } else if (
                      messagesByMe.find((message: any) => message.occasionId === a.occasionId) ==
                        null &&
                      messagesByMe.find((message: any) => message.occasionId === b.occasionId) !=
                        null
                    ) {
                      return -1; // Move b to the bottom
                    } else {
                      return a.fullName.localeCompare(b.fullName); // Sort alphabetically by fullName
                    }
                  })
                  .map((item: any, index) => (
                    <BirthCard className="birthCard" key={index}>
                      <CustomAvatar
                        className="avatar"
                        src={`${item.profilePictureUrl as string}`}
                        alt=""
                        key={item.occasionId}
                      />
                      <Box className="birthCard_content">
                        <Box>
                          <Box className="user">{item.fullName}</Box>
                          <Box className="designation">{`${item.designationName as string}`}</Box>
                          {/* view message sent by me */}
                          {messagesByMe.find(
                            (message: any) => message.occasionId === item.occasionId
                          ) != null ? (
                            <Button
                              onClick={() => {
                                handleShowWishOpen(item.occasionId);
                              }}
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                                color: "#D42C2C",
                                fontWeight: "500"
                              }}
                            >
                              <FiMessageSquare />
                              <Box sx={{ fontSize: "12px" }}>View wish</Box>
                            </Button>
                          ) : (
                            ""
                          )}
                        </Box>
                        {messagesByMe.find(
                          (message: any) => message.occasionId === item.occasionId
                        ) != null ? (
                          <Box className="notify">
                            <BiMessageSquareCheck /> Wish sent
                          </Box>
                        ) : (
                          <CustomButton
                            variant="contained"
                            color="error"
                            label={"Send Wish"}
                            sx={{ mt: 0, textWrap: "noWrap" }}
                            onClick={() => {
                              handleSendWishDialogOpen(item.occasionId);
                            }}
                          />
                        )}
                      </Box>
                    </BirthCard>
                  ))}
              </>
            ) : (
              // no data
              <Box className="noDataBox">
                <CakeOutlinedIcon />
                <Box component="span">No birthday candles to blow today, party postponed!</Box>
              </Box>
            )}
          </Box>

          {/* message by me and send Message Popup */}
          <Box component="div" sx={{ mb: "1rem" }}>
            {allbirthdayToday != null && allbirthdayToday?.length >= 1 ? (
              <Grid sx={{ overflow: "auto", maxHeight: "200px" }}>
                {allbirthdayToday?.map((item: any) => (
                  <React.Fragment key={item.occasionId}>
                    {showWish === item.occasionId && (
                      <Dialog
                        PaperProps={{
                          style: {
                            // height: "550px",
                            // display: "flex",
                            // justifyContent: "center",
                            // alignItems: "center",
                            // width: "100%",
                            overflow: "initial"
                          }
                        }}
                        open={showWish}
                        onClose={handleShowWishClose}
                      >
                        <BirthCard className="birthCard cardView" style={{ marginTop: 0 }}>
                          <Avatar
                            className="avatar"
                            src={`${item.profilePictureUrl as string}`}
                            alt=""
                          />
                          <Box className="birthCard_content">
                            <Box sx={{ flex: 1 }}>
                              <Box className="user">
                                <Box component="span">{item.fullName}</Box>
                              </Box>
                              <Box className="designation">{`${
                                item.designationName as string
                              }`}</Box>

                              <Box>
                                {messagesByMe.find(
                                  (message: any) => message.occasionId === item.occasionId
                                ) != null ? (
                                  <Box
                                    sx={{
                                      color: "#D42C2C",
                                      fontWeight: "500",
                                      mt: 2
                                    }}
                                  >
                                    <Box sx={{ fontSize: "16px" }}>
                                      {messagesByMe?.find(
                                        (message: any) => message.occasionId === item.occasionId
                                      )?.wishedMessage ?? null}
                                    </Box>
                                  </Box>
                                ) : (
                                  ""
                                )}
                              </Box>
                              <Box sx={{ width: "100%", textAlign: "end" }}>
                                <Box component="span" className="date">
                                  ~{" "}
                                  {dayjs(
                                    messagesByMe?.find(
                                      (message: any) => message.occasionId === item.occasionId
                                    )?.wishedOn ?? null
                                  ).format("HH:mm")}
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </BirthCard>
                      </Dialog>
                    )}

                    {/* dialog box */}

                    {sendWishDialogOpen === item.occasionId && (
                      <Grid
                        item
                        lg={12}
                        sx={{
                          marginLeft: 9,
                          marginRight: 7
                        }}
                      >
                        <Dialog
                          PaperProps={{
                            style: {
                              minHeight: "300px",
                              width: "100%"
                            }
                          }}
                          open={sendWishDialogOpen}
                          onClose={handleSendWishDialogClose}
                        >
                          <DialogContent sx={{ width: "100%" }}>
                            <BirthCard className="birthCard" style={{ marginTop: 0 }}>
                              <Avatar
                                className="avatar"
                                src={`${item.profilePictureUrl as string}`}
                                alt=""
                              />
                              <Box className="birthCard_content">
                                <Box>
                                  <Box className="user">{item.fullName}</Box>
                                  <Box className="designation">{`${
                                    item.departmentName as string
                                  }, ${item.designationName as string}`}</Box>
                                </Box>
                              </Box>
                            </BirthCard>

                            <TextField
                              autoFocus
                              multiline
                              margin="dense"
                              id="name"
                              label={`Send ${
                                item.fullName.match(/^\S+/)?.[0] as string
                              } a birthday wish and make his day!`}
                              fullWidth
                              variant="standard"
                              value={wishMessage}
                              onChange={(e) => {
                                const value = e.target.value.slice(0, 280);
                                if (value.length < 280) {
                                  setErrorMessage("");
                                } else {
                                  setErrorMessage("maximum length reached");
                                }
                                setWishMessage(value);
                              }}
                              helperText={errorMessage.length > 0 && errorMessage}
                              FormHelperTextProps={{
                                sx: {
                                  fontSize: "10px",
                                  color: "red"
                                }
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      sx={{ color: "#D42C2C" }}
                                      size="large"
                                      onClick={() => {
                                        setShowPicker(!showPicker);
                                      }}
                                    >
                                      <EmojiEmotionsOutlinedIcon />
                                    </IconButton>{" "}
                                  </InputAdornment>
                                )
                              }}
                            />
                            {showPicker && (
                              <Box display="flex" justifyContent="center" alignItems="center">
                                <EmojiPicker
                                  skinTonesDisabled={true}
                                  lazyLoadEmojis={true}
                                  width="100%"
                                  onEmojiClick={onEmojiClick}
                                />
                              </Box>
                            )}
                          </DialogContent>
                          <DialogActions>
                            <Button variant="outlined" onClick={handleSendWishDialogClose}>
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              color="error"
                              onClick={() => {
                                if (wishMessage.length === 0) {
                                  setErrorMessage("Please Write a Message");
                                } else {
                                  void sendWishMessage(item.occasionId, item.fullName, wishMessage);
                                }
                              }}
                            >
                              Send
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Grid>
                    )}
                  </React.Fragment>
                ))}
              </Grid>
            ) : (
              ""
            )}
          </Box>
        </>
      )}
    </>
  );
};
export default BirthdayCelebration;
